import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BreadcrumbService } from 'libraries/hotel/services/breadcrumb.service';

import { Observable } from 'rxjs';
import { faChevronRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
    @Output()
    public readonly onClick: EventEmitter<string> = new EventEmitter();

    public breadcrumb: Observable<any>;

    public icon: IconDefinition = faChevronRight;

    constructor (
        private breadcrumbService: BreadcrumbService
    ) { }

    public ngOnInit (): void {
        this.breadcrumb = this.breadcrumbService.getItems();
    }

    public itemClick (item: string): void {
        this.onClick.emit(item);
    }
}
